import { render, staticRenderFns } from "./SlidePanel.vue?vue&type=template&id=0cba066a&scoped=true&"
import script from "./SlidePanel.vue?vue&type=script&lang=js&"
export * from "./SlidePanel.vue?vue&type=script&lang=js&"
import style0 from "./SlidePanel.vue?vue&type=style&index=0&id=0cba066a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba066a",
  null
  
)

export default component.exports